// src/utils/AdminNotificationContext.js
import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { AuthContext } from './AuthContext';
import { getPendingLaps } from './firestoreUtils';

const AdminNotificationContext = createContext();

export const useAdminNotifications = () => {
  const context = useContext(AdminNotificationContext);
  if (!context) {
    throw new Error('useAdminNotifications must be used within an AdminNotificationProvider');
  }
  return context;
};

export const AdminNotificationProvider = ({ children }) => {
  const { user } = useContext(AuthContext);
  const [pendingLapsCount, setPendingLapsCount] = useState(0);

  const checkPendingLaps = useCallback(async () => {
    if (!user || user.role !== 'admin') {
      setPendingLapsCount(0);
      return;
    }

    try {
      const pendingLaps = await getPendingLaps();
      setPendingLapsCount(pendingLaps.length);
    } catch (error) {
      console.error('Error checking pending laps:', error);
      setPendingLapsCount(0);
    }
  }, [user]);

  useEffect(() => {
    checkPendingLaps();
  }, [checkPendingLaps]);

  // Check for pending laps every 5 minutes for admins
  useEffect(() => {
    if (!user || user.role !== 'admin') return;

    const interval = setInterval(() => {
      checkPendingLaps();
    }, 300000); // 5 minutes

    return () => clearInterval(interval);
  }, [user, checkPendingLaps]);

  return (
    <AdminNotificationContext.Provider value={{ pendingLapsCount, checkPendingLaps, refreshPendingLaps: checkPendingLaps }}>
      {children}
    </AdminNotificationContext.Provider>
  );
};